export enum EditAction {
  FREE_DAYS,
  EVENTS
}

export enum BillableEventView {
  LIST = 'LIST',
  FORM = 'FORM'
}
